import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '~/constants/keys'
import { getToolkitsBySlug } from '~/generated/client'
import { useGetAllToolkits } from '~/hooks/query/tools'
import { getDuration } from '~/utils/duration'

export const useGetToolkit = (toolkitSlug: string) => {
  const {
    data: { items: toolkits = [] },
    isLoading,
    isError,
    isSuccess,
  } = useGetAllToolkits({
    page: 1,
  })

  const toolkitData = useMemo(
    () => toolkits.find((toolkit) => toolkit.slug === toolkitSlug),
    [toolkits, toolkitSlug],
  )

  return { toolkitData, isLoading, isError, isSuccess }
}
export const useToolkitInfo = (key: string) => {
  const {
    data: appInfo,
    isLoading: isAppInfoLoading,
    isError,
  } = useQuery({
    queryKey: QUERY_KEYS.getAppScreenQueryKey(key),
    queryFn: () =>
      getToolkitsBySlug({
        slug: key,
      }),
    staleTime: getDuration({
      days: 1,
    }),
  })

  return {
    appInfo,
    isAppInfoLoading,
    isError,
  }
}
